import moment from 'moment';

const init = {
    start: { value: moment().hour(12).minute(0).second(0), valid: true },
    end: { value: moment().hour(12).minute(0).second(0), valid: true },
};

export default init;
